// One Enroll Hosts runner shared by the tray and the drawer (PCD-9663). See enrollmentRuns.spec.md.

import type { ReactNode } from 'react'
import { createContext, useContext, useState } from 'react'
import type { EnrollmentRunner } from './useEnrollmentRunner'
import useEnrollmentRunner from './useEnrollmentRunner'

// ENT-FR-005: the tray hides while an Enroll Hosts drawer is open so it never covers the
// drawer footer. The drawer flips this on mount and back on unmount.
export interface EnrollmentRunnerContextValue extends EnrollmentRunner {
  drawerOpen: boolean
  setDrawerOpen: (open: boolean) => void
}

const EnrollmentRunnerContext = createContext<EnrollmentRunnerContextValue | null>(null)

export const EnrollmentRunnerProvider = ({ children }: { children: ReactNode }) => {
  const runner = useEnrollmentRunner()
  const [drawerOpen, setDrawerOpen] = useState(false)
  return (
    <EnrollmentRunnerContext.Provider value={{ ...runner, drawerOpen, setDrawerOpen }}>
      {children}
    </EnrollmentRunnerContext.Provider>
  )
}

export const useEnrollmentRunnerContext = (): EnrollmentRunnerContextValue => {
  const runner = useContext(EnrollmentRunnerContext)
  if (!runner) {
    throw new Error('useEnrollmentRunnerContext must be used inside EnrollmentRunnerProvider')
  }
  return runner
}
